/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { ChartProps } from '../../Chart.props';
import { PieChartHeaderAlignment, SliceOptions } from './PieChart.defs';

export interface PieChartProps extends ChartProps {
  /**
   * The classes to apply to the Pie Chart.
   */
  classes?: string;

  /**
   * The data and its config to display in the Pie Chart.
   */
  chartData: Array<SliceOptions>;

  /**
   * The formatter function for the data labels.
   */
  dataLabelFormatter?: (dataLabelObj: Highcharts.PointLabelObject) => string;

  /**
   * The color of the connector.
   */
  connectorColor?: string;

  /**
   * The width of the connector.
   */
  connectorWidth?: number;

  /**
   * Controls whether to disable tooltip.
   */
  disableTooltip?: boolean;

  /**
   * Controls whether chart should remain unresponsive to any user effects.
   */
  staticChart?: boolean;

  /**
   * The position of the header (title, subtitle) in a pie chart.
   */
  headerPosition?: keyof typeof PieChartHeaderAlignment;

  /**
   * Controls whether to hide the legend of the pie chart.
   */
  hideLegend?: boolean;

  /**
   * The name of the series.
   */
  seriesName: string;
}

export const pieChartDefaultProps: PieChartProps = {
  chartData: [],
  classes: 'sds-pie-chart',
  seriesName: 'Series 1',
  subtitle: 'Pie chart subtitle',
  title: 'Pie chart',
};
